export default __webpack_public_path__ + "static/tabs-hierarchy-dont-8775894e890d73090f305d736cf6cffe7efa4a2409ed84d76df2e62f5ffb9e09.png";